import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BookOpen } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/context/SeoContext";

export default function GazettePage() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  }, []);

  return (
    <div data-testid="gazette-page" className="mx-auto max-w-7xl px-4 py-12 sm:px-8">
      <Seo pageKey="gazette" />
      <div className="mb-10">
        <p className="eyebrow flex items-center gap-2"><BookOpen size={14} /> La Gazette de la Ruche</p>
        <h1 className="mt-2 font-serif text-4xl font-semibold tracking-tight text-bark sm:text-5xl">
          Bienfaits &amp; recettes
        </h1>
        <p className="mt-3 max-w-xl text-base text-bark-soft">
          Les nouvelles du rucher, nos recettes de famille et tout ce que les abeilles nous apprennent.
        </p>
      </div>

      {!posts ? (
        <p data-testid="gazette-loading" className="py-20 text-center font-serif text-xl text-bark-soft">La ruche s'active…</p>
      ) : (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {posts.map((post, i) => (
            <motion.article
              key={post.slug}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              data-testid={`gazette-card-${post.slug}`}
              className="group overflow-hidden rounded-2xl border border-amber-800/15 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              <Link to={`/gazette/${post.slug}`} data-testid={`gazette-link-${post.slug}`}>
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={post.image_url} alt={post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <p className="text-xs uppercase tracking-[0.15em] text-amber-deep">{post.tag} · {post.read_time}</p>
                  <h2 className="mt-2 font-serif text-xl font-semibold leading-snug text-bark group-hover:text-amber-deep">{post.title}</h2>
                  <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-bark-soft">{post.excerpt}</p>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      )}
    </div>
  );
}
